// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"68c3ae94","453":"af277223","547":"f35fe53b","923":"62884013"}[chunkId] + ".chunk.js";
};